import { render } from "./UserInvoices.vue?vue&type=template&id=90bfa94e&ts=true"
import script from "./UserInvoices.ts?vue&type=script&lang=ts"
export * from "./UserInvoices.ts?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__